import { Modal, Typography } from "antd";
import React from "react";
import Phone from "../../assets/images/app/phone_verif.svg";

const { Text } = Typography;

interface ModificationModalProps {
    visible: boolean;
    onCancel: () => void;
}

const PhoneModificationModal: React.FC<ModificationModalProps> = ({ visible, onCancel }) => {

    return (
        <Modal
            title={null}
            visible={visible}
            onCancel={onCancel}
            footer={null}
            centered
        >
            <div style={{ textAlign: "center" }}>
                <img src={Phone} height={70} style={{ marginBottom: "10px" }}></img>
                <Text strong style={{ display: "block", marginBottom: 8 }}>
                    Modification du numéro de téléphone
                </Text>
                <Text>
                    Si tu veux modifier le numéro de téléphone déjà authentifié, merci de nous <a href="/contact" target="_blank">contacter</a> en spécifiant ta demande de modification (et en précisant l'indicatif Pays).
                </Text>
            </div>
        </Modal>
    );
};

export default PhoneModificationModal;
